import { FC, HTMLAttributes, ReactElement } from 'react';

import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useIsLandscape, useIsLargerThanWide, useIsPortrait } from '@pp/core/src/styles/hooks/media';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';

import { BalanceMidSection } from './balanceMid/BalanceMidSection';
import { BalanceWingConnected } from './balanceWingConnected/BalanceWingConnected';
import { TotalBetWingConnected } from './totalBetWingConnected/TotalBetWingConnected';

import styles from './BalanceFooter.module.css';

interface BalanceFooterProps extends HTMLAttributes<HTMLDivElement> {}

export const BalanceFooter: FC<BalanceFooterProps> = ({ className = '' }): ReactElement => {
  const isShowKeyPad = useHighflyerGameStateSlice.toggleKeypad();
  const inDesktopMode = useIsLargerThanWide();
  const isPortrait = useIsPortrait();
  const isLandScape = useIsLandscape();
  const jurisdiction = useConfigSlice.playerConfig()?.jurisdiction;
  const hideBonusBalance = useConfigSlice.getShouldMergeBonusBalance();
  const displayBonusBalance = !hideBonusBalance || jurisdiction === 'X1';

  const showMidDiv = (isPortrait && displayBonusBalance) || (!inDesktopMode && isLandScape);

  const isKeypadOpened = useModifiers(styles, 'balanceFooter', {
    keypadOpened: isShowKeyPad.autoCashOut || isShowKeyPad.keypad,
  });
  return (
    <div className={`${styles.BalanceFooter} ${isKeypadOpened} ${className}`}>
      <BalanceWingConnected />
      {showMidDiv && <BalanceMidSection />}
      <TotalBetWingConnected />
    </div>
  );
};
